<template>
    <div class="container">
        <Sub_WidgetsClock></Sub_WidgetsClock>
        <Sub_WidgetsWeather></Sub_WidgetsWeather>
        <Sub_WidgetsQRCode></Sub_WidgetsQRCode>
    </div>
</template>

<script setup>
    import Sub_WidgetsClock   from './Sub_WidgetsClock.vue'
    import Sub_WidgetsQRCode  from './Sub_WidgetsQRCode.vue';
    import Sub_WidgetsWeather from './Sub_WidgetsWeather.vue';
</script>

<style lang="scss" scoped>
    .container {
        text-align: center;

        display: flex;
        flex-direction: column;
        align-items: center;

        gap: 2rem;
    }
</style>